import { useEffect } from 'react'
import debounce from 'lodash/debounce'
import camelCase from 'lodash/camelCase'
import { warning } from '@react/react-spectrum/Toast/js/ToastContainer'
import { useProjectSubscription, useScreenSubscription } from 'services/project'

const showConflictWarning = debounce((msg) => warning(msg, { timeout: 0 }), 30000, { leading: true, trailing: false })

const conflictWarningContent = {
  self: () =>
    `You have modified this section in different window. Continue editing in this window to overwrite them, or close it to leave incoming changes.`,
  other: (userId) =>
    `User ${userId} has just modified this section. Simultaneous changes to the same section may overwrite each other.`,
}

export function useConflictWarning({ projectId, user, tab }) {
  const projectSubscriptionData = useProjectSubscription(projectId)
  const screenSubscriptionData = useScreenSubscription(projectId)

  useEffect(() => {
    const { partName, userId, originId } = projectSubscriptionData || {}

    if (projectSubscriptionData && partName === camelCase(tab) && originId !== window['DSN'].originId) {
      if (userId !== user.id) {
        showConflictWarning(conflictWarningContent.other(userId))
      } else {
        showConflictWarning(conflictWarningContent.self())
      }
    }
  }, [projectSubscriptionData, user, tab])

  useEffect(() => {
    const { userId, originId } = screenSubscriptionData || {}

    if (screenSubscriptionData && originId !== window['DSN'].originId && camelCase(tab) === 'screens') {
      if (userId !== user.id) {
        showConflictWarning(conflictWarningContent.other(userId))
      } else {
        showConflictWarning(conflictWarningContent.self())
      }
    }
  }, [screenSubscriptionData, user, tab])
}
